export const MeetingState_Both_SelfNoShow = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/both/selfNoShow.html';
        $scope.showReschedule = false;
    },
];
